export default {
  vision_blog: "vision blog".toUpperCase(),
  stay_turned__: "Stay tuned for everything happening on Vision.".toUpperCase(),
};
